interface ABTestStats {
  total: number;
  running: number;
  totalCvrLift: number;
  totalSalesLift: number;
  annualizedSales: number;
}

interface ABTestStatsBannerProps {
  stats: ABTestStats;
}

export function ABTestStatsBanner({ stats }: ABTestStatsBannerProps) {
  return (
    <div className="flex items-center gap-6 rounded-lg border border-border bg-card px-4 py-3 text-sm">
      <div>
        <span className="text-muted-foreground">Total tests</span>{" "}
        <span className="font-semibold">{stats.total}</span>
      </div>
      <div>
        <span className="text-muted-foreground">Running</span>{" "}
        <span className="font-semibold text-status-success-strong">{stats.running}</span>
      </div>
      {stats.totalCvrLift > 0 && (
        <div>
          <span className="text-muted-foreground">CVR lift</span>{" "}
          <span className="font-semibold">+{stats.totalCvrLift}%</span>
        </div>
      )}
      {stats.totalSalesLift > 0 && (
        <div>
          <span className="text-muted-foreground">Sales lift</span>{" "}
          <span className="font-semibold">${stats.totalSalesLift.toLocaleString()}</span>
        </div>
      )}
      {stats.annualizedSales > 0 && (
        <div>
          <span className="text-muted-foreground">Annualized</span>{" "}
          <span className="font-semibold">${stats.annualizedSales.toLocaleString()}</span>
        </div>
      )}
    </div>
  );
}
